import { render, staticRenderFns } from "./flowPacketModal.vue?vue&type=template&id=68277f46&scoped=true&"
import script from "./flowPacketModal.vue?vue&type=script&lang=js&"
export * from "./flowPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./flowPacketModal.vue?vue&type=style&index=0&id=68277f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68277f46",
  null
  
)

export default component.exports